const initialState = {
    clickedImage: "",
  };
  
  const clickedImageReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_CLICKED_IMAGE':
        return {
          ...state,
          clickedImage: action.payload
        };
      default:
        return state;
    }
  };
  
  export default clickedImageReducer;